"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { LandPlot, ShoppingCart } from "lucide-react";
import { cn } from "@/lib/utils";
import type { UserMode } from "@/components/map/types";
interface ModeSelectorProps {
  initialMode?: UserMode;
  onModeChange?: (mode: UserMode) => void;
}
export function ModeSelector(t0) {
  const $ = _c(23);
  const {
    initialMode: t1,
    onModeChange
  } = t0;
  const initialMode = t1 === undefined ? "landowner" : t1;
  const [mode, setMode] = useState(initialMode);
  let t2;
  if ($[0] !== onModeChange) {
    t2 = newMode => {
      setMode(newMode);
      onModeChange?.(newMode);
    };
    $[0] = onModeChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleModeChange = t2;
  let t3;
  if ($[2] !== handleModeChange) {
    t3 = () => handleModeChange("landowner");
    $[2] = handleModeChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = mode === "landowner" ? "bg-primary text-white" : "text-foreground-muted hover:bg-surface-container-low";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LandPlot className="w-4 h-4" />;
    t7 = <span>Ich habe Punkte</span>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3 || $[9] !== t5) {
    t8 = <button onClick={t3} className={t5}>{t6}{t7}</button>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== handleModeChange) {
    t9 = () => handleModeChange("buyer");
    $[11] = handleModeChange;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = mode === "buyer" ? "bg-primary text-white" : "text-foreground-muted hover:bg-surface-container-low";
  let t11;
  if ($[13] !== t10) {
    t11 = cn("flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all", t10);
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ShoppingCart className="w-4 h-4" />;
    t13 = <span>Ich brauche Punkte</span>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t12 = $[15];
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t11 || $[18] !== t9) {
    t14 = <button onClick={t9} className={t11}>{t12}{t13}</button>;
    $[17] = t11;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14 || $[21] !== t8) {
    t15 = <div className="bg-white rounded-lg shadow-lg p-1 flex gap-1">{t8}{t14}</div>;
    $[20] = t14;
    $[21] = t8;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
}